import type { KeyboardEventCode } from '@recruitee/common/keyboard';

export enum SkinColour {
  LightSkinTone = '1F3FB',
  MediumLightSkinTone = '1F3FC',
  MediumSkinTone = '1F3FD',
  MediumDarkSkinTone = '1F3FE',
  DarkSkinTone = '1F3FF',
}

export interface EmojiSkinVariation {
  unified: string;
  symbol: string;
  addedIn: number;
  hasImgTwitter: boolean;
  base: EmojiItem;
}

export type EmojiListNavigationKeys =
  | KeyboardEventCode.ArrowUp
  | KeyboardEventCode.ArrowDown
  | KeyboardEventCode.ArrowRight
  | KeyboardEventCode.ArrowLeft
  | KeyboardEventCode.Enter;

export enum SymbolVirtualScrollItem {
  Heading = 'heading',
  SymbolRow = 'symbol_row',
}

export interface EmojiItem {
  unified: string;
  symbol: string;
  shortName: string;
  shortNames: string[];
  category: string;
  sortOrder: number;
  addedIn: number;
  hasImgTwitter: boolean;
  skinVariations: Record<SkinColour, EmojiSkinVariation> | null;
}

interface EmojiDatasourceSkinVariation {
  unified: string;
  non_qualified: string | null;
  image: string;
  sheet_x: number;
  sheet_y: number;
  added_in: string;
  has_img_apple: boolean;
  has_img_google: boolean;
  has_img_twitter: boolean;
  has_img_facebook: boolean;
}

export interface EmojiDataSourceItem {
  name: string;
  unified: string;
  non_qualified: string;
  docomo: string;
  au: string;
  softbank: string;
  google: string;
  image: string;
  sheet_x: number;
  sheet_y: number;
  short_name: string;
  short_names: string[];
  text?: any;
  texts?: any;
  category: string;
  sort_order: number;
  added_in: string;
  has_img_apple: boolean;
  has_img_google: boolean;
  has_img_twitter: boolean;
  has_img_facebook: boolean;
  skin_variations: Record<SkinColour, EmojiDatasourceSkinVariation>;
  obseloted_by?: string;
}

export interface SymbolItem<T> {
  title: string;
  searchTerm: string;
  value: T;
}

export interface SymbolGroup<T> {
  label: string;
  data: Array<SymbolItem<T>>;
}

export interface SymbolDataSource<T> {
  id: string;
  label: string;
  groups: Array<SymbolGroup<T>>;
}

export enum SymbolDataSourceId {
  Emoji = 'emojis',
  MaterialIcons = 'icons',
}

export interface SymbolSelectEmoji {
  dataSourceId: `${SymbolDataSourceId.Emoji}`;
  value: EmojiItem;
}

export interface SymbolSelectIcon {
  dataSourceId: `${SymbolDataSourceId.MaterialIcons}`;
  value: string;
}
export type SymbolSelectItem = SymbolSelectEmoji | SymbolSelectIcon;

export type EmojiGroup = SymbolGroup<EmojiItem>;
export type SymbolRow = {
  type: SymbolVirtualScrollItem.SymbolRow;
  data: Array<SymbolItem<unknown>>;
};
export type SymbolHeader = { type: SymbolVirtualScrollItem.Heading; name: string };
export type SymbolVirtualScrollRow = Array<SymbolHeader | SymbolRow>;
